import { CP_Container, CP_SVG, CP_Text } from "./CircleProgress.styled";
import { COLORS } from "../../../styles";
import { rgba } from "polished";
import { useEffect, useState } from "react";

interface CircleProgressProps {
	value: number;
	size?: number;
	strokeWidth?: number;
	colorProgress?: string;
	backgroundColor?: string;
	delay?: number;
}

export const CircleProgress = ({
	value,
	size = 52,
	strokeWidth = 4,
	colorProgress = COLORS.Gold,
	backgroundColor = rgba(COLORS.White, 0.7),
	delay = 350,
}: CircleProgressProps) => {
	const safeValue = Math.min(100, Math.max(0, value));
	const [isVisible, setIsVisible] = useState(false);
	const [animatedValue, setAnimatedValue] = useState(0);

	useEffect(() => {
		setIsVisible(false);
		setAnimatedValue(0);
		const showTimer = window.setTimeout(() => {
			setIsVisible(true);
		}, delay);
		const fillTimer = window.setTimeout(() => {
			setAnimatedValue(safeValue);
		}, delay + 180);
		return () => {
			window.clearTimeout(showTimer);
			window.clearTimeout(fillTimer);
		};
	}, [safeValue, delay]);

	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;
	const offset = circumference - (animatedValue / 100) * circumference;

	return (
		<CP_Container
			$size={size}
			initial={{ opacity: 0, scale: 0.75 }}
			animate={{
				opacity: isVisible ? 1 : 0,
				scale: isVisible ? 1 : 0.75,
			}}
			transition={{
				duration: 0.25,
				ease: [0.16, 1, 0.3, 1],
			}}
		>
			<CP_SVG width={size} height={size}>
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					fill="transparent"
					stroke={backgroundColor}
					strokeWidth={strokeWidth}
				/>
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					fill="transparent"
					stroke={colorProgress}
					strokeWidth={strokeWidth}
					strokeLinecap="round"
					strokeDasharray={circumference}
					strokeDashoffset={offset}
				/>
			</CP_SVG>

			<CP_Text>{animatedValue}%</CP_Text>
		</CP_Container>
	);
};
